<script>
  import Modal from './RiderModal.svelte';
  import { raceResultsStore as data } from '../stores'; 
  export let categoryId;
  export let participants;
  let filteredList;
  
  let riderModalID;
  //let rankCircleColor = "#D3D3D3";
  //let rankCircleColor = "#64A2D8";
  let rankCircleColor = "#2368A2";
  let isLastRace = true;

  let isOpenModal = false;
  const allRiderRaces = JSON.parse(JSON.stringify($data));
  let riderRaces;

  function openModal(rider_id) {    
    riderRaces =  allRiderRaces.filter(item => item.pn === rider_id);
    isOpenModal = true;
  }

  function closeModal() {
    isOpenModal = false;
  }
 
  function nameSeperate(fullname) {
    const nameArray = (fullname.trim()).split(" ");
    let finalName = "";
    let lastName = nameArray.pop();

    finalName += "<div>" + nameArray.join(" ") + '</div><div style="font-weight:700; font-size: 1rem;">' + lastName + "</div>";
   return finalName;
  }

  function searchTable(el, cat) {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = el;
    filter = input.value.toUpperCase();
    table = document.getElementById("table_" + cat);
    tr = table.getElementsByTagName("tr");

    // Loop through all table rows, and hide those that don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }
  
  filteredList = Object.values(participants).filter(item => item.ci == categoryId);
  
  
  let filteredListPrevious = JSON.parse(JSON.stringify(filteredList));
  filteredListPrevious.sort((x,y) => {
    return y.previousRacePoints - x.previousRacePoints;
  });
  
  // calculate rank before current race
  let previousRankingMap = new Map();
  for (let i=0; i < filteredListPrevious.length; i++) {
    previousRankingMap.set(filteredListPrevious[i].pn, i + 1);
  }

  if (isLastRace) {
    filteredList.sort((x,y) => {
    return y.totalTopRacePoints - x.totalTopRacePoints;
  });
  } else {
    filteredList.sort((x,y) => {
    return y.totalPoints - x.totalPoints;
  });
  }
  

  // calculate rank upto current race
  let currentRankingMap = new Map();
  for (let i=0; i < filteredList.length; i++) {
    currentRankingMap.set(filteredList[i].pn, i + 1);
  }

  let rankingMovementMap = new Map(); // key = rider number, value = how many ranks did rider go up or down
  currentRankingMap.forEach(function(value, key) {
    let prevRank = 0;
    let rankDiff = 0;
    if (previousRankingMap.has(key)) {
      prevRank = previousRankingMap.get(key);
    }

    if (prevRank !== 0) {
     rankDiff = value - prevRank;
    }
    rankingMovementMap.set(key, rankDiff);
  })

</script>


{#if categoryId != -1}
<div style="background-color:white;" class="align-items-center">
  {#if filteredList.length > 10}
  <div style="background-color: #A8D3F5">
    <input type="text" class="searchInput shadow-inset" id="search_{categoryId}" on:keyup={searchTable(this, categoryId)} placeholder="Search for names..">
  </div>
  {/if}
  <table id="table_{categoryId}" class="table table-hover align-middle" style="font-size: 0.75rem;">
    <thead>
      <tr>
        <th scope="col">RNK</th>
        <th class="name_style" scope="col">NAME</th>
        <th scope="col">NO.</th>
        <th scope="col">PTS</th>
        <!--<th scope="col">TOP 6 PTS</th>-->
        <th scope="col">&nbsp</th>
      </tr>
    </thead>
    <tbody class="">
        {#if filteredList.length > 0}
          {#each filteredList as rider, i}
            <tr on:click={openModal(rider.pn)}>
              <th class="align-middle" scope="row">
                <div class="align-middle">
                  {#if rankingMovementMap.has(rider.pn)}
                    {#if (rankingMovementMap.get(rider.pn)) > 0 }
                      <!--<div>{i + 1}</div>-->
                      <!--<div>&nbsp;</div>-->
                      <!--<div style="margin-bottom: 4px;">-->
                      <div>
                        <svg width="30" height="30"><circle cx="15" cy="15" r="15" fill="{rankCircleColor}" /><text x="50%" y="50%" text-anchor="middle" fill="white" font-size="1.05rem" font-family="Arial" dy=".3em">{ i + 1}</text></svg>
                      </div>
                      <!--<div class="badge rounded-pill bg-danger">&#8595 {parseInt(rankingMovementMap.get(rider.pn)) * -1 }</div>-->
                      {#if !isLastRace}
                        <div class="text-danger" style="font-weight:900;">&#8595 {parseInt(rankingMovementMap.get(rider.pn)) * 1 }</div>
                      {/if}
                    {:else if (rankingMovementMap.get(rider.pn)) < 0}
                      <!--<div class="badge rounded-pill bg-success">{parseInt(rankingMovementMap.get(rider.pn)) * -1 } &#8593</div>-->
                      {#if !isLastRace}
                      <div class="text-success" style="font-weight:900;">{parseInt(rankingMovementMap.get(rider.pn)) * -1 } &#8593</div>
                      {/if}
                      <!--<div>{i + 1}</div>-->
                      <!--<div style="margin-top:4px;">-->
                      <div>
                        <svg width="30" height="30"><circle cx="15" cy="15" r="15" fill="{rankCircleColor}" /><text x="50%" y="50%" text-anchor="middle" fill="white" font-size="1.05rem" font-family="Arial" dy=".3em">{ i + 1}</text></svg>
                      </div>
                      <!--<div>&nbsp;</div>-->
                    {:else}
                    <!--<div>&nbsp;</div>-->
                      <svg width="30" height="30"><circle cx="15" cy="15" r="15" fill="{rankCircleColor}" /><text x="50%" y="50%" text-anchor="middle" fill="white" font-size="1.05rem" font-family="Arial" dy=".3em">{ i + 1}</text></svg>
                    <!--<div>&nbsp;</div>-->
                    {/if}
                  {/if}
                </div>
              </th>
              <!--
              <th class="align-middle">
                {#if rankingMovementMap.has(rider.pn)}
                  {#if (rankingMovementMap.get(rider.pn)) > 0 }
                    &#8595 {parseInt(rankingMovementMap.get(rider.pn)) * -1 }
                  {:else if (rankingMovementMap.get(rider.pn)) < 0}
                    {parseInt(rankingMovementMap.get(rider.pn)) * -1 } &#8593
                  {:else}
                    &nbsp;
                  {/if}
                {/if}
              </th>
            -->
              <td class="align-middle"><div class="name_style">{@html nameSeperate(rider.n)}</div></td>
              <td class="align-middle">{rider.pn}</td>
              <!--<td class="align-middle fw-bolder">{rider.totalPoints}</td>-->
              <td class="align-middle" style="font-weight: 900;">{rider.totalTopRacePoints}</td>
              <!--<td class="align-middle">
                <button type="button" class="btn btn-outline btn-sm" style="" on:click={openModal(rider.pn)}>
                  View Races
                </button>
              </td>-->
              <td class="align-middle">&#10095;</td>
            </tr>
          {/each}
        {:else}
          <tr><td colspan="5">No Riders.</td></tr>
        {/if}
      
        </tbody>
      </table>
</div>
{:else}
<div>
  <table class="table">
    <thead>
      <tr>
        <td colspan="5">No Data Available.</td>
      </tr>
    </thead>
  </table>
</div>
{/if}

<Modal riderRaces={riderRaces} isOpenModal={isOpenModal} on:closeModal={closeModal} />

<style>
  .badgeCustom {
    font-size: medium;
    color:black;
    background-color: grey;
    padding: 5px;
    border: grey solid 1px;
    border-radius: 10px;
  }

  .searchInput {
    /*background-image: url('../icon-search.svg');*/ /* Add a search icon to input */
    background-color: #EFF8FF;
    background-position: 10px 12px; /* Position the search icon */
    background-repeat: no-repeat; /* Do not repeat the icon image */
    width: 95%; /* Full-width */
    font-size: 16px; /* Increase font-size */
    padding: 10px 20px 10px 14px; /* Add some padding */
    /*border: 1px solid #ddd;*/ /* Add a grey border */
    border: 0px solid #EFF8FF;
    border-radius: 10px;
    margin: 16px auto 10px auto; /* Add some space below the input */
    color: #AAD4F6;
  }
  .shadow-inset {
    /*
    box-shadow: 0px 1px 10px -3px rgba(100,162,216,0.83) inset;
    -webkit-box-shadow: 0px 1px 10px -3px rgba(100,162,216,0.83) inset;
    -moz-box-shadow: 0px 1px 10px -3px rgba(100,162,216,0.83) inset;
*/
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.83) inset;
    -webkit-box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.83) inset;
    -moz-box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.83) inset;
  }

  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #64A2D8;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #64A2D8;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #64A2D8;
}

  table {
    margin-bottom: 0px;
    /*background-color:#EFF8FF;*/
    color: #1A4971;
  }

  thead {
    /*background-color: #F2F5F7;*/
    /*background-color: #AAD4F6;*/
    background-color: #A8D3F5;
    /*
    box-shadow: 0px 8px 8px 0px rgba(128,128,128, .60);
    -webkit-box-shadow: 0px 8px 8px 0px rgba(128,128,128, .60);
    -moz-box-shadow: 0px 8px 8px 0px rgba(128,128,128, .60);*/
    border:0px;
  }

  thead th {
    border: 0px;
    /*color: #2368A2;*/
    color: #2368A2;
  }

  tbody {
    border: 0px;
    background-color: #F0F8FF;
  }

  tbody td, tbody th {
    border: 0px;
  }

  /* Reset some of the demo app styles that interfere. */
  :global(html) {
    height: auto;
    width: auto;
    position: static;
  }
  :global(#sapper),
  :global(body) {
    display: block;
    height: auto;
  }

  .name_style {
    text-transform: uppercase;
    text-align: left;
  }

  .btn-outline {
    color: #64A2D8;
    border-color: #64A2D8;
  }

  .btn-outline:hover,
  .btn-outline:focus,
  .btn-outline.active {
    background: #64A2D8;
    color: #ffffff;
    border-color: #64A2D8;
    
  }
</style>